import React from "react";
import { useTranslation } from "react-i18next";
// Icons
import { IoClose } from "react-icons/io5";

// Components
import Typography from "../../../../../components/Typography";

// Styles
import styles from "../style.module.scss";


interface DataSettingsModalHeaderProps {
  title: string;
  subtitle?: string;
  onClose: () => void;
}

const DataSettingsModalHeader: React.FC<DataSettingsModalHeaderProps> = ({ title, subtitle, onClose }) => {
  const { t } = useTranslation();

  const _title = title || t('profile.settings.data.title');

  return (
    <div className={styles.titleContainer}>
      <div className={styles.titleContainer_content}>
        <Typography variant="h2" className={styles.title}>{_title}</Typography>

        {subtitle !== '' && subtitle !== undefined && subtitle !== null && (
          <Typography variant="p" className={styles.description}>
            {subtitle}
          </Typography>
        )}
      </div>

      <button className={styles.closeButton} onClick={onClose}>
        <IoClose />
      </button>
    </div>
  );
};

export default DataSettingsModalHeader;
